var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 34.167V26h1.417v3.375h13.75v1.417h-13.75v3.375ZM5.833 30.792v-1.417h8.417v1.417Zm7-6.709v-3.375h-7v-1.416h7v-3.375h1.417v8.166ZM19 20.708v-1.416h15.167v1.416Zm6.75-6.75V5.833h1.417v3.375h7v1.417h-7v3.333ZM5.833 10.625V9.208H21v1.417Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.248a3bcad2f5a7d36e4cf6d22ce2d6e8.svg";
export { ForwardRef as ReactComponent };